module.exports = __webpack_public_path__ + "static/img/footer.c055d99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer.svg
// module id = hxfa
// module chunks = 1